import {useLevelOrder} from "@hooks/LevelOrder";
import {useWebRTCSupport} from "@hooks/WebRTCSupport";
import {ControlButton} from "@ui/buttons/ControlButton";
import {RootButton} from "@ui/buttons/RootButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {RootIcon} from "@ui/icons/RootIcon";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

import styles from "./styles.module.scss";

export const LevelPopup = (props) => {
  const location = useLocation();

  const {t} = useTranslation();
  const {scenarioLevels, productLevels, certificationLevels} = useLevelOrder();

  const {item, close, closeWithAvatar = null} = props;
  const {serverStatus} = useSelector((state) => state.ml.chat);
  const {demo, role} = useSelector((state) => state.common.candidate);
  const {isWebRTCSupported} = useWebRTCSupport();

  const {type, value} = location?.state?.level || {};

  const level =
    scenarioLevels.find((item) => item.value === value && item.type === type) ||
    productLevels.find((item) => item.value === value && item.type === type) ||
    certificationLevels.find(
      (item) => item.value === value && item.type === type,
    );

  if (!item) return null;

  return (
    <div className={styles.levelPopup}>
      <h2 dangerouslySetInnerHTML={{__html: level?.subtitle}} />

      <H3>
        <span dangerouslySetInnerHTML={{__html: level?.title}} />
      </H3>

      <RootDesc>
        <div
          className={
            type !== "certification"
              ? styles.levelPopupText
              : styles.levelPopupTextCertification
          }
          dangerouslySetInnerHTML={{__html: level?.text}}
        />
      </RootDesc>

      {serverStatus === "loading" ? (
        <div className={styles.levelPopupSpinner}>
          <RootIcon
            width={26}
            height={26}
            id={"spinner-upload"}
          />
        </div>
      ) : (
        <div className={styles.levelPopupSettings}>
          <div className={styles.levelPopupButtons}>
            {close && (
              <ControlButton
                color={"var(--violet)"}
                onClick={close}
                txt={
                  demo && role === "Representative"
                    ? t("button.start_chat")
                    : t("button.continue_without_avatar")
                }
              />
            )}

            {closeWithAvatar && isWebRTCSupported && (
              <RootButton
                type={"button"}
                txt={t("button.continue_avatar")}
                onClick={closeWithAvatar}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
